<template>
  <v-card class="px-4 home-step-card" flat color="transparent">

    <!-- Desktop -->
    <div class="d-none d-md-flex align-center">
      <div class="step-image">
        <img :src="require(`@/assets/images/decorator-${step.image}.png`)" :alt="step.title" />
      </div>
      <div class="step-content pa-5 d-flex flex-column">
        <h3 class="step-title mb-2">{{ step.title }}</h3>
        <p class="step-text mb-4">{{ step.text }}</p>
        <div class="step-links">
          <v-btn
            v-for="link in step.links"
            :key="link.href || link.type"
            v-bind="linkProps(link)"
            class="tonal-button"
          >
            <v-icon v-if="!isRouterLink(link) && link.type !== 'internal'" left small>mdi-arrow-right</v-icon>
            {{ link.title }}
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Mobil -->
    <div class="d-md-none">
      <v-row no-gutters class="mb-2">
        <v-col cols="7" class="d-flex flex-column justify-center pr-2">
          <h3 class="step-title mb-2">{{ step.title }}</h3>
          <p class="step-text mb-0">{{ step.text }}</p>
        </v-col>
        <v-col cols="5" class="d-flex align-center justify-end">
          <img :src="require(`@/assets/images/decorator-${step.image}.png`)" :alt="step.title" class="step-image-mobile" />
        </v-col>
      </v-row>
      <v-btn
        v-for="link in step.links"
        :key="link.href || link.type"
        v-bind="linkProps(link)"
        block
        class="mb-2 tonal-button"
      >
        <v-icon v-if="!isRouterLink(link) && link.type !== 'internal'" left small>mdi-arrow-right</v-icon>
        {{ link.title }}
      </v-btn>
    </div>

  </v-card>
</template>

<script>
export default {
  name: 'HomeStepCard',
  props: {
    step: {
      type: Object,
      required: true
    }
  },
  methods: {
    isRouterLink(link) {
      return link.type === 'router'
    },
    linkProps(link) {
      if (this.isRouterLink(link)) {
        return { to: link.href }
      }
      return {
        href: link.href,
        target: link.type === 'internal' ? '_self' : '_blank'
      }
    }
  }
}
</script>

<style scoped>
.home-step-card {
  border-radius: 8px;
}
.step-image {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.step-image img {
  width: 160px;
  height: auto;
}
.step-image-mobile {
  width: 100%;
  height: auto;
}
.step-content {
  flex: 1;
  min-width: 0;
}
.step-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.step-title {
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
}
.step-text {
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #444;
}
</style>
